<template>
  <div class="third-login">
    <div v-if="!isHideLine" class="space">
      <em class="line"></em>
      <span class="text">or</span>
      <em class="line"></em>
    </div>
    <div class="third-login-box" :class="isHideLine ? 'no-line' : ''">
      <template v-for="(item, index) in thirdList">
        <div v-if="loginHref[item]" :key="index" class="third-box">
          <a
            class="login-type"
            href="javascript:;"
            :class="`j-${item}-login-btn`"
            @click="loginHrefJump(loginHref[item], item)"
          >
            <em :class="item" :title="channelName[item]"></em>
          </a>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import login from '@mixins/officialWebStore/login';
import { CHANNEL_NAME } from '@store/officialWebStore/login';
import { locationType, clickButton } from '@plugins/biPoint/_configWebstoreV2';
export default {
  mixins: [login],
  data() {
    return {
      channelName: CHANNEL_NAME
    };
  },
  computed: {
    ...mapState({
      gameId: state => state.gameId
    }),
    // 是否隐藏分割线
    isHideLine() {
      // 2024.6.25 休闲三消全球版286是游客模式但是没有OTP和用户中心，需要特殊处理隐藏OTP登录
      const isHideLineGames = [286];
      return isHideLineGames.includes(+this.gameId);
    },
  },
  watch: {
    gameId: {
      immediate: true,
      handler(newVal) {
        if (!newVal) {
          return;
        }
        this.getThirdPartyLogin();
      }
    }
  },
  methods: {
    loginHrefJump(href, loginType) {
      clickButton({
        btnName: 'third_login_clike',
        locationKey: locationType.loginPopup,
        otherParams: {
          loginType: loginType
        }
      });
      window.open(href, '_self');
    }
  }
};
</script>

<style scoped lang="scss">
@import '@assets/scss/officialWebStore/_dimen.scss';
.third-login {
  .space {
    display: flex;
    line-height: 30px;
    text-align: center;
    padding: 0 58px;
    margin-bottom: 30px;
    .line {
      width: 276px;
      border-top: 2px solid #d2d2d2;
      margin-top: 15px;
    }
    .text {
      font-size: 22px;
      color: #000;
      font-weight: bold;
      margin: auto 10px;
    }
  }
  &-box {
    font-size: 0;
    text-align: center;
    margin-bottom: 30px;
    &.no-line {
      margin-top: 30px;
    }
    .third-box {
      display: inline-block;
      .login-type {
        text-decoration: none;
        display: inline-block;
        margin: auto 25px auto;
        .facebook,
        .twitter,
        .line,
        .naver,
        .apple,
        .googleplay {
          width: 68px;
          height: 68px;
        }
      }
    }

    @each $icon in facebook, twitter, kakao, line, naver, googleplay, apple, vk
    {
      .#{$icon} {
        background: url($tmslgImg + $icon + '.png') no-repeat center center;
        background-size: contain;
        width: 68px;
        height: 68px;
        display: block;
        margin: auto;
        transition: all 0.2s;
      }
    }
  }
}
</style>


